// Get Unmasking Connections
export const GET_UNMASKING_CONNECTIONS_REQUEST = 'GET_UNMASKING_CONNECTIONS_REQUEST';
export const GET_UNMASKING_CONNECTIONS_DONE = 'GET_UNMASKING_CONNECTIONS_DONE';
export const GET_UNMASKING_CONNECTIONS_FAILED = 'GET_UNMASKING_CONNECTIONS_FAILED';

// Operations
export const UNMASKING_CONNECTIONS_SET_PAGE = 'UNMASKING_CONNECTIONS_SET_PAGE';
export const TOGGLE_UNMASKING_CONNECTIONS = 'TOGGLE_UNMASKING_CONNECTIONS';
export const TOGGLE_ALL_UNMASKING_CONNECTIONS = 'TOGGLE_ALL_UNMASKING_CONNECTIONS';